<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div class="table-wrapper mat-elevation-z1">
  <table mat-table [dataSource]="dataSource" class="full-width">
    <!-- Dynamically generate column definitions -->
    <ng-container *ngFor="let col of displayedColumns; let i = index" [matColumnDef]="col">
      <th mat-header-cell *matHeaderCellDef>
        {{ getColumnTitle(i, col) }}
      </th>
      <td mat-cell *matCellDef="let row">
        <!-- Show as a link when an anchor is provided; otherwise show as normal text -->
        <a
          *ngIf="hasAnchor(row?.[col]); else plainCell"
          href=""
          (click)="$event.preventDefault(); onCellAnchorClick(row, col)"
        >
          {{ getDisplayValueFromRow(row, col) }}
        </a>
        <ng-template #plainCell>
          {{ getDisplayValue(row?.[col]) }}
        </ng-template>
      </td>
    </ng-container>
    <!-- header -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <!-- data row -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="empty-row" *ngIf="!dataSource.data || !dataSource.data.length">
      <td class="empty-cell" [attr.colspan]="displayedColumns.length || 1">
        No Data Found
      </td>
    </tr>
  </table>
</div>
